import { CFormInput, CFormLabel, CFormText } from '@coreui/react-pro'
import React, { useState } from 'react'
import './PasswordField.scss'

const PasswordField = ({
  invalidPassword,
  onPasswordChange,
  password,
  errormessage,
  label,
  disabled,
  onKeyDown = () => {},
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState()

  return (
    <div className="password-holder">
      <CFormLabel className="plabel">{label ? label : 'Password'}</CFormLabel>
      <div className="password-field">
        <CFormInput
          disabled={disabled}
          className={`input-field ${invalidPassword && 'invalid-input-field'}`}
          type={isPasswordVisible ? 'text' : 'password'}
          errormessage="Please enter a valid password"
          onChange={(e) => onPasswordChange(e.target?.value)}
          onKeyDown={onKeyDown}
          value={password}
        />
        <div className="eye-button">
          {!isPasswordVisible ? (
            <i
              className="fa-regular fa-eye-slash"
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            ></i>
          ) : (
            <i
              className="fa-light fa-eye"
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            ></i>
          )}
        </div>
      </div>

      <span className={`label-container error-container ${invalidPassword && 'active'}`}>
        <CFormText className={`error-message `} component={'div'}>
          {errormessage ? errormessage : ''}
        </CFormText>
      </span>
    </div>
  )
}

export default PasswordField
